import { Coordinate } from 'ol/coordinate';
import { PATH } from '../constants/paths';

export enum CardSearchParamName {
  tableName = 'table',
  recordId = 'record',
  layerName = 'layer',
}

export enum MapLinkParamName {
  zoom = 'zoom',
  center = 'center',
  layersName = 'layersName',
}

export const buildRecordCardLinkHash = (
  tableName: string,
  recordId: string | number,
  layerName?: string,
) => {
  return `${PATH.MAP}${buildRecordCardSearchQuery(
    tableName,
    recordId,
    layerName,
  )}`;
};

export const changeCardDataHash = (
  hash: string,
  tableName: string,
  recordId: string,
  layerName?: string,
) => {
  const search = getSearchFromHash(hash);
  const params = new URLSearchParams(search);

  params.set(CardSearchParamName.tableName, tableName);
  params.set(CardSearchParamName.recordId, recordId);

  if (layerName) params.set(CardSearchParamName.layerName, layerName);

  return `#${PATH.MAP}?${params}`;
};

export const deleteCardDataFromHash = (hash: string) => {
  const search = getSearchFromHash(hash);
  const params = new URLSearchParams(search);

  params.delete(CardSearchParamName.tableName);
  params.delete(CardSearchParamName.recordId);
  params.delete(CardSearchParamName.layerName);

  return `#${PATH.MAP}?${params}`;
};

export const buildRecordCardSearchQuery = (
  tableName: string,
  recordId: string | number,
  layerName?: string,
) => {
  const query = new URLSearchParams({
    [CardSearchParamName.tableName]: tableName,
    [CardSearchParamName.recordId]: '' + recordId,
  });

  if (layerName) {
    query.set(CardSearchParamName.layerName, layerName);
  }

  return '?' + query;
};

export const getRecordCardDataFromSearch = (str: string) => {
  const query = new URLSearchParams(str);

  const tableName = query.get(CardSearchParamName.tableName);
  const recordId = query.get(CardSearchParamName.recordId);
  const layerName = query.get(CardSearchParamName.layerName);

  if (!tableName || !recordId) return;

  return {
    tableName,
    recordId,
    layerName: layerName || undefined,
  };
};

export const getDataFromMapLink = (str: string) => {
  const query = new URLSearchParams(str);

  const zoom = query.get(MapLinkParamName.zoom);
  const center = query.get(MapLinkParamName.center);
  const layersName = query.get(MapLinkParamName.layersName);

  if (!zoom || !center) return;

  return {
    zoom,
    center,
    layersName: layersName || undefined,
  };
};

export const changeMapPropHash = (
  hash: string,
  zoom: number,
  center: Coordinate | undefined,
) => {
  const search = getSearchFromHash(hash);
  const params = new URLSearchParams(search);
  params.set(MapLinkParamName.zoom, `${zoom}`);
  if (center) params.set(MapLinkParamName.center, `${center}`);

  return `#${PATH.MAP}?${params}`;
};

export const changeMapLayerHash = (
  hash: string,
  layersName: string[] | undefined,
) => {
  const urlSearch = getSearchFromHash(hash);
  const params = new URLSearchParams(urlSearch);
  if (layersName && layersName.length > 0) {
    params.set(MapLinkParamName.layersName, `${layersName.join()}`);
  } else {
    params.delete(MapLinkParamName.layersName);
  }

  return `#${PATH.MAP}?${params}`;
};

export const getSearchFromHash = (hash: string) => {
  const queryStart = hash.indexOf('?');

  if (queryStart === -1) return '';

  const searchParams = new URLSearchParams(hash.slice(queryStart + 1));

  return '?' + searchParams.toString();
};
